import { makeStyles } from "@material-ui/core/styles";

export const ShopFormJss = makeStyles(theme => ({
  formGrid: {
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    display: "flex",
    gap: "5px"
  },
  formGridTooltip: {
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    display: "flex",
    gap: "5px"
  },
  formGridTitle: {
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(7),
    paddingTop: theme.spacing(6),
    color: '#000000',
    fontWeight: 900,
    fontSize: '1.25rem'
  },
  formGridText: {
    paddingLeft: theme.spacing(7),
    fontFamily: 'Barlow',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#464646',
    display: "flex",
    gap: "5px"
  },
  formGridTextTooltip: {
    paddingBottom: theme.spacing(2),
    fontFamily: 'Barlow',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#464646',
    display: "flex",
    gap: "5px"
  },
  gridGroup: {
    marginLeft: 'auto',
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    },
  },
  otherMarketplaceInput: {
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    '& .MuiChip-root': {
      color: theme.palette.white.main,
      backgroundColor: theme.palette.primary.main,
    },
    '& .MuiChip-deleteIcon': {
      color: theme.palette.white.main,
    },
    '& .MuiFormHelperText-root': {
      textAlign: 'right'
    }
  },
  textFieldInput: {
    backgroundColor: '#FFFFFF'
  },
  searchIcon: {
    position: "absolute",
    borderLeftColor: "3%"
  },
  insideModal: {
    paddingLeft: theme.spacing(7),
    paddingRight: theme.spacing(7),
    textAlign: 'center',
    '& p': {
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'justify',
      color: '#464646',
    },
    '& img': {
      height: '156px',
      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.4))',
    }
  },
  titleModal: {
    fontFamily: 'Barlow',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center',
    color: '#434343',
  }  
}));
